<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- TEXT STYLES -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              LIST ITEMS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row class="mt-5">
              <div class="col-6">
                <h2>
                  Mini
                </h2>
              </div>
            </b-row>
            <b-row>
              <div class="col-3">
                <ul class="list">
                  <li>
                    <span>Content</span>
                  </li>
                </ul>
              </div>

              <div class="col-3">
                <ul class="list with-icon">
                  <li>
                    <i />
                    <span>
                      <b-img src="https://lorempixel.com/125/125/technics/8/"
                             rounded="circle"
                             blank
                             width="32"
                             height="32"
                             blank-color="#777"
                      /> Content
                    </span>
                  </li>
                </ul>
              </div>
              <div class="col-3">
                <ul class="list with-img">
                  <li>
                    <b-img src="https://lorempixel.com/125/125/technics/8/"
                           rounded="circle"
                           blank
                           width="32"
                           height="32"
                           blank-color="#777"
                    />
                    <span>Content</span>
                  </li>
                </ul>
              </div>
            </b-row>
            <b-row class="mt-5">
              <div class="col-6">
                <h2>
                  Single Line
                </h2>
              </div>
            </b-row>
            <b-row>
              <div class="col-3">
                <ul class="list md">
                  <li>
                    <span class="with-right-action">Content
                      <span class="right-action">
                        <i />
                        <i />
                      </span>
                    </span>
                  </li>
                </ul>
              </div>

              <div class="col-3">
                <ul class="list md">
                  <li>
                    <span class="with-right-action">Content
                      <span class="right-action">
                        Right action
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </b-row>
            <b-row class="mt-5">
              <div class="col-10">
                <h2>
                  Two Line
                </h2>
                <p>
                  Çoklu satıra uygundur. Yüksekliğı sabit değil
                  <b>'padding'</b> değerine göre belirlenir. Sağ kısımdaki
                  <b>'right action'</b> veya ikon bölümü dikey ortalıdır.
                </p>
                <p class="bold mt-3">
                  16px padding
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <ul class="list lg">
                  <li>
                    <div class="content">
                      <p>
                        Content
                        <br>
                        <small class="xs">Description example</small>
                      </p>
                      <i class="icon-edit" />
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-3">
                <ul class="list lg">
                  <li>
                    <div class="content">
                      <p>
                        Content
                        <br>
                        <small class="xs">Description example</small>
                      </p>
                      <p>
                        right value
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-10">
                <p class="bold">
                  16px 24px padding
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <ul class="list lg">
                  <li class="pl-24">
                    <div class="content">
                      <p>
                        Content
                        <br>
                        <small class="xs">Description example</small>
                      </p>
                      <i class="icon-edit" />
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-3">
                <ul class="list lg">
                  <li class="p-16-0-24-0">
                    <div class="content">
                      <p>
                        Content
                        <br>
                        <small class="xs">Description example</small>
                      </p>
                      <p>
                        right value
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-10">
                <h2>
                  Multiline w/ title
                </h2>
                <p>
                  Üst kısımda
                  <b>'Two Line'</b> componentinin aynısını kullanır. Alt açıklama kısmı 16px 24px padding değerine sahiptir.
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-4">
                <ul class="list lg">
                  <li class="pl-24">
                    <div class="content">
                      <p>
                        Hürriyet Gazetecilik
                        <br>
                        <small class="xs">Front-End Developer</small>
                      </p>
                      <p>
                        right value
                      </p>
                    </div>
                  </li>
                </ul>
                <div class="bg-white list-content">
                  <p>
                    Think back over your life. Think about the people that had a positive influence on you. If your past was like mine, many of them didn’t realize the impact they made. The influence was usually due to them caring about you and doing some little thing. What little things have been done for you that changed your life? What little things have you done for someone else that might have changed theirs.
                  </p>
                </div>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Text',
  data() {
    return {};
  },
  computed: {},
};
</script>
